export enum PositionType {
  Left = "left",
  Right = "right",
  Center = "center",
  Top = "top",
  Bottom = "bottom"
}

export enum TriggerEvent {
  MouseEnter = "mouseenter",
  Click = "click"
}

export enum Dimension {
  Height = "height",
  Width = "width"
}

export enum JustifyContentType {
  Start = "flex-start",
  Center = "center",
  End = "flex-end"
}

export enum ScreenType {
  Desktop = "desktop",
  Mobile = "mobile",
  Tablet = "tablet"
}

export enum MediaType {
  Audio = "Audio",
  Image = "Image",
  Video = "Video"
}

export enum DirectionType {
  Left = "left",
  Right = "right"
}
